import * as React from 'react';
import * as main from "../../main.module.scss";
import * as offer from "./style.module.scss";
export const Offer = () => {
  return (
    <section className={offer.offer}>
      <div className="container">
        <h2 className={main.title}>НА ВЕБИНАРЕ ВАС ЖДЁТ:</h2>
        <div className={offer.wrapper}>
          <div className={offer.block}>
            <img src="https://fs.advance.ru/landing-pages/webinar/kak_vyuchit_anglijskij_za_3_mesyaca/icon-1-practica.svg" alt=""/>
            <h4>ПРАКТИКА <br/>ЯЗЫКА</h4>
            <ul>
              <li>Произношение сложных звуков
              </li>
              <li>Грамматика и лёгкий способ её учить
              </li>
              <li>Изучение слов со скоростью 100 слов в час</li>
            </ul>
          </div>
          <div className={offer.block}>
            <img src="https://fs.advance.ru/landing-pages/webinar/kak_vyuchit_anglijskij_za_3_mesyaca/icon-2-mistake.svg" alt=""/>
            <h4>РАБОТА НАД ОШИБКАМИ</h4>
            <ul>
              <li>Почему вы всё ещё не заговорили на английском
              </li>
              <li>Что считается полезным, но на деле мешает учить язык</li>
            </ul>
          </div>
          <div className={offer.block}>
            <img src="https://fs.advance.ru/landing-pages/webinar/kak_vyuchit_anglijskij_za_3_mesyaca/icon-3-motivation.svg" alt=""/>
            <h4>ЗАРЯД МОТИВАЦИИ</h4>
            <ul>
              <li>Как помогает правильное целеполагание
              </li>
              <li>Какие мифы не дают вам продуктивно учиться</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};
